import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Auth from '../containers/Auth';
import Header from '../components/Header';
import { BaseContainer as BaseContainerStyles } from '../styledComponents/layout';
import './reset.css';
import './index.css';
import Footer from '../components/Footer'
const Container = BaseContainerStyles.extend`
  padding-top: 0;
`;

const TemplateWrapper = (props) => {
  const children = props.children;
  const data = props.data;
  const tags = props.data.allTag.edges.map(edge => edge.node);
  const episodes = props.data.allEpisode.edges.map(edge => edge.node);
  const entertainers = props.data.allEntertainer.edges.map(edge => edge.node);
  const meta = data.site.siteMetadata;
  return (
    <div>
      <Helmet
        title={meta.title}
        meta={[
          {name: 'description', content: meta.description},
          {name: 'keywords', content: meta.keywords},
          {property: "og:type", content: meta.ogType},
          {property: "og:url", content: meta.ogUrl},
          {property: "og:title", content: meta.ogTitle},
          {property: "og:description", content: meta.ogDescription},
          {property: "og:image", content: meta.ogImage},
          {property: "og:locale", content: meta.ogLocale},
          {name: "twitter:card", content: meta.twitterCard},
          {name: "twitter:site", content: meta.twitterSite},
          {name: "twitter:creator", content: meta.twitterCreator},
          {name: "robots", content:meta.robots}
        ]}
      />
      <Header
        background={
          'background-image: linear-gradient(116deg, #08AEEA 0%, #2AF598 100%)'
        }
        title={data.site.siteMetadata.title}
      />
      <Container>
        {children({
          ...props,
          meta: meta,
          tags: tags,
          episodes: episodes,
          entertainers: entertainers,

        })}
      </Container>
      <Footer {...props}/>
    </div>
  );
};

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  data: PropTypes.object,
};

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        keywords
        description
        ogType
        ogUrl
        ogTitle
        ogDescription
        ogImage
        ogLocale
        twitterCard
        twitterSite
        twitterCreator
        firebaseSubDomain
        firebaseAPN
        firebabseISI
        firebaseIBI
        firebaseDynamicLink
        robots
      }
    }
    allTag(filter: {isPublished: {eq: true}}, sort:{fields:[orderNumber], order:ASC}) {
      edges {
        node {
          id
          tagId
          orderNumber
          name
          episodes {
            id
            orderNumber
          }
        }
      }
    }
    allEntertainer(filter: {isPublished: {eq: true}}, sort: {fields: [orderNumber], order: ASC}) {
      edges {
        node {
          entertainerId
          parentEntertainerId
          isGuest
          name
          nameKana
          orderNumber
          profile
          thumbnailUrl
          isPublished
          episodes {
            id
            orderNumber
          }
        }
      }
    }
    allEpisode(filter:{isPublished: {eq:true}}, sort:{fields:[orderNumber], order:ASC}) {
      edges {
        node {
          episodeId
          title
          isPublished
          orderNumber
          posterUrl
          programId
          summary
          thumbnailUrl
          tags {
            id
            orderNumber
          }
        }
      }
    }
  }
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js